import Resource from './common/resource';

class Tasks extends Resource {
  path = 'tasks';
}

export default Tasks;
